import axios, { endPoints } from 'utils/api';

const SET_LIST = 'categories/SET_LIST';
const SET_LOADING = 'categories/SET_LOADING';
const SET_ERROR = 'categories/SET_ERROR';

export const setCategoriesList = (data) => ({ type: SET_LIST, data });
export const setCategoriesLoading = (loading) => ({ type: SET_LOADING, loading });
export const setCategoriesError = (error) => ({ type: SET_ERROR, error });

const INITIAL_STATE = {
    list: [],
    listLoading: false,
    listError: null
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case SET_LIST:
            return { ...state, list: [...action.data], listError: null };

        case SET_LOADING:
            return { ...state, listLoading: action.loading };

        case SET_ERROR:
            return { ...state, listError: action.error, listLoading: false };

        default:
            return state;
    }
}

// /categories returns the master list as a plain array of {id, title, ...}.
// Question.categories stores integer FKs into this list. Cached after first
// successful fetch since the list is small and rarely changes.
export const fetchCategories = () => async (dispatch, getState) => {
    const state = getState().categories || {};

    if ((state.list && state.list.length > 0) || state.listLoading) return;

    dispatch(setCategoriesLoading(true));

    try {
        const response = await axios.get(endPoints.categories);
        const data = Array.isArray(response.data) ? response.data : (response.data?.data || []);

        dispatch(setCategoriesList(data));
    } catch (error) {
        dispatch(setCategoriesError(error.message || 'Failed to load categories'));
    } finally {
        dispatch(setCategoriesLoading(false));
    }
};
